import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bytedance/Desktop/gatsby/src/components/BlogLayout/index.js";
import P from '../../../components/Panel.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h3>{`解释`}</h3>
    <P mdxType="P">
死锁是指两个或两个以上的进程在执行过程中,由于竞争资源或者由于彼此通信而造成的一种阻塞的现象。
若无外力作用,它们都将无法推进下去。
此时称系统处于死锁状态或系统产生了死锁,这些永远在互相等待的进程称为死锁进程。
    </P>
    <h3>{`产生条件`}</h3>
    <P style={{
      background: '#4AC29A'
    }} mdxType="P">
互斥：在一段时间内某资源只由一个进程占用,必须释放后其他的进程才能使用。<br />
请求和保持：指进程已经保持至少一个资源,但又提出了新的资源请求,
而该资源已被其它进程占有,此时请求进程阻塞,但又对自己已获得的其它资源保持不放。<br />
不剥夺：指进程已获得的资源,在未使用完之前,不能被剥夺,只能在使用完时由自己释放。<br />
环路等待：指在发生死锁时,必然存在一个进程——资源的环形链p0=>p1=>p2=>p0<br />
    </P>
    <h3>{`预防`}</h3>
    <P style={{
      background: 'lightblue'
    }} mdxType="P">
破坏产生死锁原因中的任意某个条件,如:有序资源分配法,银行家算法
    </P>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      